import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/content/images/brands-bg/thor_bg.jpg")